import cx from 'classnames';
import { useSelector } from 'react-redux';

import { usePageGenerationContext } from 'components/Pages/Admin/Page/common/AIPageGeneration/PageGenerationContext';
import LandingPagesContainer from 'components/shared/LandingPage/components/Grid';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useScrollLandingToTop } from 'hooks/useScrollLandingToTop';
import { isLoginAsSelector } from 'store/auth/selectors';
import { isSuperAdminSelector } from 'store/user/selectors';

import Actions from './Actions';
import { useScrollToNewDefaultAnchor } from './functions';
import styles from './index.module.css';
import FormBuilderNav from './Nav';
import ScrollArrowLink from './ScrollArrowLink';

export function FormBuilder({
  children,
  withNav,
  navLinks,
  className,
  sectionClassName,
  isItinerariesItem = false,
  landingTheme,
  defaultActiveAnchor,
  actionsClassName,
  noTopPadding,
  withoutCustomCSS,
}) {
  const { isTabletOrMobile } = useMediaBreakpoints();
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const isOverriding = useSelector(isLoginAsSelector);
  const isCustomCSSEnabled = (isSuperAdmin || isOverriding) && !isTabletOrMobile && !withoutCustomCSS;
  const { cardState, isShowAIActions } = usePageGenerationContext();
  const isShowAction = isShowAIActions || isCustomCSSEnabled;

  const containerClasses = cx(
    styles.landingPagesContainer,
    !withNav && styles.withoutNav,
    isShowAction && 'withActions',
    cardState === 'loading' && styles.disableScroll,
    className,
  );
  useScrollToNewDefaultAnchor(defaultActiveAnchor);
  useScrollLandingToTop();

  return (
    <div className={cx(styles.section, sectionClassName, 'custom-section')}>
      {withNav && !isTabletOrMobile && (
        <FormBuilderNav
          landingTheme={landingTheme}
          links={navLinks}
          isItinerariesItem={isItinerariesItem}
          isLoading={cardState === 'loading'}
        />
      )}

      <Actions
        withNav={withNav}
        isItinerariesItem={isItinerariesItem}
        isCustomCSSEnabled={isCustomCSSEnabled}
        wrapperClassName={actionsClassName}
        noTopPadding={noTopPadding}
      />

      <LandingPagesContainer className={containerClasses}>
        {children}

        {navLinks?.length > 1 && !isTabletOrMobile && (
          <ScrollArrowLink links={navLinks} isItinerariesItem={isItinerariesItem} landingTheme={landingTheme} />
        )}
      </LandingPagesContainer>
    </div>
  );
}
